import React from 'react';

// eslint-disable-next-line boundaries/element-types
import { TrialProjectProcessing } from '@/pages/ProjectPage/components/Content/components/TrialProjectProcessing';

type LandingFlowLoaderProps = {
  landingProgress: number;
};

export const LandingFlowLoader: React.FC<LandingFlowLoaderProps> = ({ landingProgress }) => {
  return <TrialProjectProcessing overridePercent={landingProgress} />;
};
